// `storage` events do not fire in the tab that changed localStorage.  This
// event keeps the React shell in sync immediately after login/logout.
export const AUTH_STATE_EVENT = 'spes-auth-state-changed';

export function notifyAuthStateChanged() {
  window.dispatchEvent(new Event(AUTH_STATE_EVENT));
}
